// extracted by mini-css-extract-plugin
module.exports = {"base":"organism1-m__base__3mVW-","medium-storycard":"organism1-m__medium-storycard__1Twya"};